export const GET_LIST_ULTRA_MIKRO = 'UltraMikroGetList/Success';
export const LOADING_LIST_ULTRA_MIKRO = 'UltraMikroGetList/Loading';
export const GET_SUMMARY_ULTRA_MIKRO = 'UltraMikroGetSummary/Success';
export const LOADING_SUMMARY_ULTRA_MIKRO = 'UltraMikroGetSummary/Loading';
export const INFINITE_SCROLL_ULTRA_MIKRO = 'UltraMikroInfiniteScroll/Success';
export const LOADING_INFINITE_SCROLL_ULTRA_MIKRO = 'UltraMikroInfiniteScroll/Loading';
export const GET_DETAIL_ULTRA_MIKRO = 'UltraMikroGetDetail/Success';
export const LOADING_DETAIL_ULTRA_MIKRO = 'UltraMikroGetDetail/Loading';